var map = {
	"./Green-VeryLow.png": 965,
	"./Green-VeryLow.svg": 2404,
	"./Red-Excessive.png": 961,
	"./Red-Excessive.svg": 2405,
	"./RedYellow-Significant.png": 962,
	"./RedYellow-Significant.svg": 2406,
	"./White-Unknown.png": 582,
	"./White-Unknown.svg": 2407,
	"./Yellow-Moderate.png": 963,
	"./Yellow-Moderate.svg": 2408,
	"./YellowGreen-Low.png": 964,
	"./YellowGreen-Low.svg": 2409
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2403;


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map ^\.\/.*$
// module id = 2403
// module chunks = 1